module.exports = __webpack_public_path__ + "media/images/controls-b79c8575852c44c3acde6fd9eb254f3a.png";